export default "data:application/octet-stream;base64,JGZvbnQtcGF0aDogICAnYXNzZXRzL2ZvbnRzJyAhZGVmYXVsdDsKQGltcG9ydCAiaXJhbnNhbnMiOwpAaW1wb3J0ICJmb250aWNvbiI7"